<template>
  <!-- The More/Less toggle under a clamped block of text.

       px-2 keeps real padding around the label at every string length, and
       ml-n2 pulls that padding back out so the glyphs still line up with the
       text above. Relying on the button's own min-width for the gap instead
       (px-0) only looks padded while the label is short: "Less" fits inside
       the 50px min-width, but German "Weniger" overflows it and ends up flush
       against the hover pill. Same pattern as the comment reply toggles. -->
  <BrandButton
    variant="text"
    size="small"
    class="px-2 ml-n2"
    @click="emit('update:modelValue', !modelValue)"
  >
    {{ modelValue ? t('cta.show_less') : t('cta.show_more') }}
  </BrandButton>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import BrandButton from '@/components/global/brand/BrandButton.vue'

defineProps({
  // Whether the block it toggles is currently expanded.
  modelValue: Boolean,
})

const emit = defineEmits(['update:modelValue'])

const { t } = useI18n()
</script>
